import React from 'react';
import { useAppStateContext } from 'src/appState/AppState';
import { ChevronWrapper } from 'src/ui/components/collapse/sports/05/Collapse.style';
import {
    ArrowRight,
    RowLinkDetails,
    RowLinkLabel,
    TableSportsRowLinkFlag,
    TableSportsRowLinkWrapper,
} from 'src/ui/components/table/sports/row/link/TableSportsRowLink.style';
import { observer } from 'src/utils/mobx-react';

interface TableSportsRowLinkPropsType {
    className?: string;
    dataTest?: string;
    flagCode?: string;
    formattedDate: string;
    formattedTime: string;
    handleClick: () => void;
    label: string;
}

export const TableSportsRowLink = observer(
    'TableSportsRowLink',
    ({
        className,
        dataTest,
        flagCode,
        formattedDate,
        formattedTime,
        handleClick,
        label,
    }: TableSportsRowLinkPropsType): JSX.Element => {
        const {
            componentVariants: { sportsbookVariant },
            unifiedSportEventsTable,
        } = useAppStateContext().unifiedComponentConfig;
        return (
            <TableSportsRowLinkWrapper
                className={className}
                onClick={handleClick}
                data-test={dataTest ?? 'table-sports-row-link-wrapper'}
                variant={sportsbookVariant}
            >
                {flagCode !== undefined && (
                    <TableSportsRowLinkFlag
                        flagCode={flagCode}
                        dataTest='table-sports-row-link-flag'
                    />
                )}

                <RowLinkLabel data-test='table-sports-row-link-label'>{label}</RowLinkLabel>
                {formattedDate !== '' && <RowLinkDetails variant={sportsbookVariant}>{formattedDate}</RowLinkDetails>}
                {formattedTime !== '' && <RowLinkDetails variant={sportsbookVariant}>{formattedTime}</RowLinkDetails>}
                {unifiedSportEventsTable ? (
                    <ChevronWrapper
                        size={20}
                        position={'right'}
                    />
                ) : (
                    <ArrowRight
                        position='right'
                        variant={sportsbookVariant}
                    />
                )}
            </TableSportsRowLinkWrapper>
        );
    }
);
